import { connect } from 'react-redux'

import { createLead } from '../../../../actions/leadActionCreators'

const mapStateToProps = ({ busy, lead, appConfig }, ownProps) => ({
  enableRunningFor: appConfig.enableRunningFor,
  busy: busy,
  initialValues: {
    ...lead, // for email and address
    ...ownProps,
  },
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (values) => dispatch(createLead(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/components/Position/RunModal/LeadForm/leadFormContainer.js